import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ModalXoa } from "./ModalXoa";

export const BtnXoa = ({ item }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <a onClick={handleShow} href={() => false}>
        <PopoversBootrap
          contentText="Xoá"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
          <img src="/app-assets/images/icon-xoa-v2.png" />
        </PopoversBootrap>
      </a>

      {show && (
        <ModalXoa show={show} onHide={handleClose} thuChiId={item.ThuChiID} />
      )}
    </>
  );
};
